import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './CCPContainer.css';

const CCPContainer = props => {
  const [ccpWidth, setCCPWidth] = useState(95);
  useEffect(() => {
    if (props.width) {
      setCCPWidth(props.width);
    }
  }, [props]);

  return (
    <div
      id="ccp"
      style={{
        height: '85vh',
        width: ccpWidth + 'vw',
        marginLeft: '32px',
        marginRight: '32px',
        marginTop: '20px',
        border: props.contactAttributes.borderColor ? '5px solid ' + props.contactAttributes.borderColor : 'none',
        borderRadius: '14px'
      }}
    />
  );
};

CCPContainer.propTypes = {
  width: PropTypes.number,
  contactAttributes: PropTypes.shape({
    borderColor: PropTypes.string,
  }).isRequired,
};

export default CCPContainer;
